import type { ReactNode } from 'react'

import { DatepickerInput } from '../baseInputs'

type Props = {
  helper?: ReactNode
  showAmPm?: boolean
  showTime?: boolean
}

const Date = ({ helper, showAmPm, showTime, ...rest }: Props) => {
  const name = 'date'
  const label = 'Date'

  return (
    <DatepickerInput
      name={name}
      label={label}
      helper={helper}
      showAmPm={showAmPm}
      showTime={showTime}
      {...rest}
    />
  )
}

export default Date
